import axios from 'axios';

export default class PostsList {
    constructor() {
        this._currentPage = 1;
        this._itemsPerPage = 9;
        this._totalPages = 0;
        this._currentSearch = '';
        this._cancelToken = null;
        this._loader = document.querySelector('.actus__items__loader');
        this._itemsContainer = document.querySelector('.actus__items');
        this._loadMoreButton = document.querySelector('.actus__items__load__more button');
        this._searchInput = document.querySelector('.actus__search__form .search-post-input');
        this._searchButton = document.querySelector('.actus__search__form .search__form__submit');
        this._searchFormResult = document.querySelector('.actus__search__form__result');
        this._catInputs = Array.from(document.querySelectorAll('.actus__cat input'));
        // this._baseUrl = window['baseURL'].url;
        this._baseUrl = window.location.origin;
    }
    render() {
        if (this._itemsContainer) {
            this.loadCurrentPage();
            this._loadMoreButton.addEventListener(
                'click',
                () => {
                    this.loadCurrentPage();
                },
                false,
            );
            this._searchButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.doSearch();
            });
            this._searchInput.addEventListener('keypress', (e) => {
                if (e.key === 'Enter') this.doSearch();
            });
            this._catInputs.forEach((item) => {
                item.addEventListener('change', (e) => {
                    if (item.value === '-1') {
                        if (item.checked) {
                            const checkedCats = Array.from(
                                document.querySelectorAll('.actus__cat input:not([value="-1"]):checked'),
                            );
                            checkedCats.forEach((item) => {
                                item.checked = false;
                            });
                        }
                    }
                    this.setupInputs();
                    this.doSearch();
                });
            });
        }
    }

    setupInputs() {
        const checkedCats = Array.from(document.querySelectorAll('.actus__cat input:not([value="-1"]):checked'));
        if (checkedCats.length === 0) {
            document.querySelector('.actus__cat input[value="-1"]').checked = true;
        } else {
            document.querySelector('.actus__cat input[value="-1"]').checked = false;
        }
    }

    doSearch() {
        const searchTerm = this._searchInput.value.trim();
        this._itemsContainer.innerHTML = '';
        this._currentSearch = searchTerm;
        this._currentPage = 1;
        this.loadCurrentPage();
    }

    loadCurrentPage() {
        let categories = '';
        const checkedCats = Array.from(document.querySelectorAll('.actus__cat input:checked'));
        let values = [];
        checkedCats.forEach((item) => {
            values.push(item.value);
        });
        if (values.length == 0 || values.includes('-1')) {
            // no cat, do nothing
        } else {
            categories = '&categories=' + values.join(',');
        }
        this._loader.classList.remove('hidden');
        this._loadMoreButton.classList.add('hidden');
        const method = '/wp-json/wp/v2/posts';
        let baseUrl = `${this._baseUrl}${method}?per_page=${this._itemsPerPage}&page=${this._currentPage}${categories}`;
        if (this._currentSearch !== '') {
            baseUrl += '&search=' + this._currentSearch;
        }
        if (this._cancelToken !== null) this._cancelToken.cancel();
        this._cancelToken = axios.CancelToken.source();
        const wpFetchHeaders = {
            cancelToken: this._cancelToken.token,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Expose-Headers': 'x-wp-total',
            },
        };
        axios
            .get(baseUrl, wpFetchHeaders)
            .then((resp) => {
                this._totalPages = parseInt(resp.headers['x-wp-totalpages']);
                this._currentPage++;
                this._loader.classList.add('hidden');
                this._cancelToken = null;
                this.addPosts(resp.data);
                this.setupDisplayLoadMore();
                this.setupDisplaySearchResults(parseInt(resp.headers['x-wp-total']));
            })
            .catch((error) => {});
    }

    setupDisplaySearchResults(num) {
        if (this._currentSearch !== '') {
            this._searchFormResult.classList.remove('hidden');
            this._searchFormResult.querySelector('.num').innerHTML = num;
            this._searchFormResult.querySelector('.searchTerm').innerHTML = this._currentSearch;
            if (num > 1) {
                this._searchFormResult.querySelector('.plural').classList.remove('hidden');
            } else {
                this._searchFormResult.querySelector('.plural').classList.add('hidden');
            }
        } else {
            this._searchFormResult.classList.add('hidden');
        }
    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;
        return [day, month, year].join('.');
    }

    addPosts(posts) {
        let output = '';
        posts.forEach((post) => {
            const date = this.formatDate(post.date);
            output += '<div class="post__item">';
            output += '<div class="post__item__img">';
            output += '<a href="' + post.link + '" title="' + post.title.rendered + '">';
            output += post.thumbTag;
            output += '</a>';
            output += '</div>';
            output += '<div class="post__item__text">';
            output += '<div class="post__item__meta">';
            output += '<div class="post__item__cats">' + post.cats + '</div>';
            output += '<div class="post__item__date"> - ' + date + '</div>';
            output += '</div>';
            output += '<div class="post__item__title">';
            output += '<a href="' + post.link + '" title="' + post.title.rendered + '">';
            output += post.title.rendered;
            output += '</a>';
            output += '</div>';
            output += '<div class="post__item__excerpt">';
            output += post.customExcerpt;
            output += '</div>';
            output += '</div>';
            output += '</div>';
        });
        this._itemsContainer.insertAdjacentHTML('beforeend', output);
    }

    setupDisplayLoadMore() {
        if (this._currentPage <= this._totalPages) {
            this._loadMoreButton.classList.remove('hidden');
        } else {
            this._loadMoreButton.classList.add('hidden');
        }
    }
}
